import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useProductTicketContainerStyles } from './styles';

import InfoMessageIcon from '../../../../common/icons/ic_svg_notificacion.svg';
const ProductTicketContainer = ({ ...props }) => {
  const { ticket } = props;
  const classes = useProductTicketContainerStyles();
  return (
    <Box display="flex" padding="7px 16px">
      <img className={classes.icon} src={InfoMessageIcon} />
      <Typography data-cy="typographyProductTicket">
        <strong>
          Nº Ticket de solicitud:
          <span> {ticket.ticketId} </span>
        </strong>
        - {ticket.typeName}: {ticket.motiveName}
      </Typography>
    </Box>
  );
};

ProductTicketContainer.propTypes = {
  ticket: PropTypes.object,
};

export default ProductTicketContainer;
